<template>
  <v-app >
    <v-navigation-drawer v-model="drawer" app v-if="$store.getters.isAuthenticated">
      <navigation />
      <template v-slot:append>
        <div class="text-caption text-center px-0 mt-auto d-block py-0">Version {{ appversion }}</div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="black" dark v-if="$store.getters.isAuthenticated" :src="require('./assets/logo.jpg')">
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          class="ml-14 mt-1"
          max-height="90%"
          width="200px"
        ></v-img>
      </template>
      <v-badge
              color="red"
              offset-x="20"
              offset-y="20"
              class="ma-0 pa-0"
              content=""
              :value="false"
              style="position:relative;left:-14px"
            >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-badge>
      <v-spacer></v-spacer>
      <v-toolbar-title class="hidden-sm-and-down" v-if="this.$store.getters.getProfile.feuerwehr">
        {{ this.$store.getters.getProfile.feuerwehr.feuerwehr }}
      </v-toolbar-title>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>
    <v-footer color="black" dark app class="footer py-3">
      <pwa />
      <span class="white--text">&copy; {{ new Date().getFullYear() }} X-trasoft IT-Services</span>
      <v-spacer></v-spacer>
      <v-icon small :class="{ 'nfc-spin': nfc_initializing }" :color="!nfc_supported ? 'grey' : (nfc_inited ? 'green' : 'red')" :style="nfc_supported && !nfc_inited ? 'cursor:pointer' : ''" @click="onNfcIconClick">mdi-nfc-variant</v-icon>
      <v-spacer></v-spacer>
      <v-badge offset-y="11px" offset-x="-5px" class="mr-4" :color="online ? 'green' : 'red'" dot>{{ this.$store.getters.getProfile.user ? this.$store.getters.getProfile.user : "Version "+appversion }}</v-badge>
    </v-footer>
  </v-app>
</template>

<script>
/* global NDEFReader */
import axios from 'axios';
import navigation from '@/components/menu';
import { USER_REQUEST } from "@/store/actions/user";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import pwa from './components/PWA.vue';
import {version} from './../package'
import emitter from './eventBus.js'; // Importieren Sie den Event-Bus

export default {
  name: 'App',
  components: {
    navigation,
    pwa,
  },
  data: () => ({
    drawer: null,
    logged_in: false,
    online: true,
    appversion: "",
    nfc_inited:false,
    nfc_supported:false,
    nfc_initializing:false,
  }),
  created: function() {
    this.appversion = version
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST);
      this.updateBirthdayBadge();
    }
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function () {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch(AUTH_LOGOUT)
        }
        throw err;
      });
    });
  },
  computed:{

  },
  mounted(){
    window.addEventListener('online', () => this.online = true);
    window.addEventListener('offline', () => this.online = false);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible' && this.$store.getters.isAuthenticated) {
        this.updateBirthdayBadge();
        this.$store.dispatch(USER_REQUEST);
      }
      // Nach Hintergrund/Sperrbildschirm ist die NFC-Sitzung meist beendet -> neu starten
      if (document.visibilityState === 'visible' && this.nfc_inited) {
        this.nfc_inited = false
        this.initNfc()
      }
    });
    this.initNfc()
    // Einrichtung aus den Einstellungen: emitter.emit('nfc-init', {resolve})
    emitter.on('nfc-init', this.onNfcInitRequest)
  },
  beforeDestroy(){
    emitter.off('nfc-init', this.onNfcInitRequest)
    if (this.nfcAbort) this.nfcAbort.abort()
  },
  methods:{
    // force: laufenden Startversuch abbrechen und neu beginnen (z.B. nach Tipp auf das Icon, damit die
    // Berechtigungsabfrage mit Nutzerinteraktion erscheint)
    async initNfc(force = false){
      this.nfc_supported = 'NDEFReader' in window;
      if (!this.nfc_supported) return false;
      if (this.nfc_initializing && !force) return false;
      if (this.nfc_inited && !force) return true;
      if (this.nfcAbort) this.nfcAbort.abort();
      const abort = new AbortController();
      this.nfcAbort = abort;
      this.nfc_inited = false;
      this.nfc_initializing = true;
      try {
          // Referenz muss gehalten werden, sonst räumt der Browser den Reader auf und es wird nur 1x gelesen
          const ndef = new NDEFReader();
          this.nfcReader = ndef;
          ndef.onreading = (event) => {
            const serialNumber = event.serialNumber;
            let data = {serialNumber: serialNumber ,text: null, url: null}
            const records = event.message.records;
            for (const record of records) {
              if (record.recordType === "text") {
                const textDecoder = new TextDecoder(record.encoding);
                data.text = textDecoder.decode(record.data);
              } else if (record.recordType === "url") {
                data.url = new TextDecoder().decode(record.data);
              }
            }

            emitter.emit('nfc-read', data);
          };
          ndef.onreadingerror = (error) => {
              console.error(`Lesefehler: ${error.message}. Ist das Tag NDEF-formatiert?`);
          };
          await ndef.scan({ signal: abort.signal });
          if (this.nfcAbort === abort) this.nfc_inited = true;
          return this.nfc_inited;
      } catch (error) {
          if (this.nfcAbort === abort) console.error('NFC-Reader konnte nicht initialisiert werden', error)
          return false;
      } finally {
          if (this.nfcAbort === abort) this.nfc_initializing = false;
      }
    },
    async onNfcInitRequest(payload){
      const ok = await this.initNfc(true);
      if (payload && payload.resolve) payload.resolve(ok);
    },
    async onNfcIconClick(){
      if (!this.nfc_supported || this.nfc_inited) return;
      // Auch während der Icon "kreiselt": Startversuch mit Nutzerinteraktion wiederholen
      const ok = await this.initNfc(true);
      if (!ok) {
        alert('NFC-Reader konnte nicht initialisiert werden. Bitte prüfen Sie, ob NFC am Gerät eingeschaltet ist und die Berechtigung erteilt wurde. Tippen Sie in der Adressleiste links neben der URL auf das Schloss-Symbol oder die Website-Informationen. Gehen Sie auf Berechtigungen. Erlauben Sie dort den Zugriff auf NFC-Geräte, falls er blockiert wurde.')
      }
    },
    async updateBirthdayBadge(){
      if (!('setAppBadge' in navigator)) {
        console.log('Badging API wird von diesem Browser/Gerät nicht unterstützt (iOS benötigt >= 16.4 und die App muss zum Home-Bildschirm hinzugefügt sein).');
        return;
      }
      try {
        const result = await axios({
          url: process.env.VUE_APP_APIURL+"mannschaft/get",
          method: 'GET' })
        if (result.status == 200) {
          const anzahl = result.data.filter(item => item.geburtstagsinfo == 0).length;
          if (anzahl > 0) {
            await navigator.setAppBadge(anzahl);
          } else {
            await navigator.clearAppBadge();
          }
        }
      } catch (error) {
        console.error('Geburtstags-Badge konnte nicht gesetzt werden', error);
      }
    }
  },
};
</script>

<style  scoped>
  .v-toolbar__content{
    padding-left: 2px !important;
  }
  .footer{
    font-size:0.8rem;
  }
  .nfc-spin{
    animation: nfc-spin 1s linear infinite;
  }
  @keyframes nfc-spin{
    from{ transform: rotate(0deg); }
    to{ transform: rotate(360deg); }
  }
</style>